<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">
      <div class="page-header">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4>Campaign</h4>
            <h6>Edit Campaign</h6>
          </div>
        </div>
        <ul class="table-top-head">

          <li>
            <a ref="collapseHeader" data-bs-toggle="tooltip" data-bs-placement="top" title="Collapse"
               @click="toggleCollapse(collapseHeader.value)">
              <i data-feather="chevron-up" class="feather-chevron-up"></i>
            </a>
          </li>
        </ul>
        <div class="page-btn d-flex gap-1">
          <a @click="saveCampaign()" href="javascript:void(0);" class="btn btn-added">
            <vue-feather type="plus-circle"
                         class="me-2"></vue-feather>
            Save</a>

          <router-link style="color: var(--PRIMARY-COLOR) !important;" :to="cancelRoute"
                       class="btn btn-added bg-white">
            <vue-feather type="x" class="me-2"></vue-feather>
            Cancel
          </router-link>
        </div>
      </div>


      <div class="row">
        <!-- Form -->
        <div class="col-lg-8">
          <div class="card">
            <div class="card-body">
              <CampaignForm ref="campaignForm" v-model="campaign" />
            </div>
          </div>
        </div>

        <!-- Preview -->
        <div class="col-lg-4">
          <CampaignPreview :campaign="campaign" />
        </div>
      </div>

    </div>
  </div>

</template>

<script setup>

import {toggleCollapse} from "@/utils/components";
import CampaignPreview from "@/views/pages/Campaign/components/campaign-preview.vue";
import CampaignForm from "@/views/pages/Campaign/components/campaign-form.vue";
import {useCampaignStore} from "@/store/campaignStore";
import {onMounted, ref} from "vue";
import {useRoute, useRouter} from "vue-router";

const cancelRoute = {name: "campaign-list"};
const campaignStore = useCampaignStore();

const route = useRoute();
const router = useRouter();
const action = route.params.action;
const encodedData = route.params.encodedData || null;
const collapseHeader = ref(null);
const campaignForm = ref(null);

const campaign = ref({
  id: '',
  greeting: '',
  description: '',
  type: '',
  start_date: '',
  end_date: '',
  action_text: '',
  action_url: '',
  color_code: '',
  message: '',
  amount: null,

  media_item_id: null,
  media_item_url: null,
  amount_raised: null

});

function formatForInput(value) {
  if (!value) return '';
  // If it has a space instead of 'T', convert it for the input element
  return value.replace(' ', 'T').slice(0, 16);
}

function formatDateForApi(value) {
  if (!value) {
    return null;
  }
  // Ensures 'T' is always replaced with a space and seconds are appended if missing
  let formatted = value.replace('T', ' ');
  if (formatted.length === 16) {
    formatted += ':00';
  }
  return formatted;
}

function buildPayload() {
  return {
    greeting: campaign.value.greeting,
    description: campaign.value.description,
    type: campaign.value.type,

    start_date: formatDateForApi(campaign.value.start_date),
    end_date: formatDateForApi(campaign.value.end_date),

    action_text: campaign.value.action_text,
    action_url: campaign.value.action_url,
    color_code: campaign.value.color_code,
    message: campaign.value.message,
    amount: campaign.value.amount,

    media_item_id: campaign.value.media_item_id,
  };
}

async function saveCampaign() {
  if (!campaignForm.value.validate()) {
    return;
  }

  try {
    const payload = buildPayload();

    const campaignId = campaign.value.id;
    const success = await campaignStore.updateCampaign(campaignId, payload);

    if (success) {
      await router.push({name: "campaign-list"});
    }

  } catch (error) {

  }

}


onMounted(async () => {
    try {
      // Decode base64 and parse
      const decoded = JSON.parse(atob(encodedData));
      // Check if campaignId is present
      if (decoded.campaignId) {
        // Try to find it in the store first
        let storedCampaign = campaignStore.campaigns.find(
            (p) => p.id === decoded.campaignId
        );

        // 2. IF NOT FOUND (e.g., on page reload), fetch the data!
        if (!storedCampaign) {
          // Note: If you have a method to fetch a single campaign (like fetchCampaign(id)), use that instead!
          // Otherwise, fetch all campaigns so the store is populated again.
          await campaignStore.fetchCampaigns();

          // Try finding it again now that the store has data
          storedCampaign = campaignStore.campaigns.find(
              (p) => p.id === decoded.campaignId
          );
        }

        if (storedCampaign) {
          // Populate the podcast object with the stored data
          campaign.value = {
            id: storedCampaign.id || "",
            greeting: storedCampaign.greeting || "",
            type: storedCampaign.type || "",
            description: storedCampaign.description || "",
            message: storedCampaign.message || "",
            start_date: formatForInput(storedCampaign.start_date) || "",
            end_date: formatForInput(storedCampaign.end_date) || "",
            action_text: storedCampaign.action_text || "",
            action_url: storedCampaign.action_url || "",
            amount: storedCampaign.amount || null,
            media_item_id: storedCampaign.thumbnail?.id || "",
            media_item_url: storedCampaign.thumbnail?.url || "",
            color_code: storedCampaign.color?.color_code,
            amount_raised: storedCampaign.amount_raised || null
          };

          // set image preview if media item exists
          if (storedCampaign.thumbnail?.url) {
            campaign.value.media_item_url = storedCampaign.thumbnail.url;
          }

        } else {
          console.warn(
              `Campaign with ID ${decoded.campaignId} not found in store.`
          );
        }
      } else {
        console.warn("Decoded data does not contain a campaignId field:", decoded);
      }
    } catch (error) {
      console.error("Failed to decode campaign data:", error);
    }
});


</script>

<style scoped>

</style>